import React from "react";
import Header from "./components/Header";
import GroupingBoards from "./components/GroupingBoards";
import { useSelector } from "react-redux";
import { Button, Stack } from "@mui/material";
import icon from "../../../styles/svg/critical_priority.svg";
import { useTeams } from "../../../utils/reactQuery/teams";

const AllocationGrouping = React.memo(() => {
  const userTeamId = useSelector((state) => state.users.logInUser.team_id);
  const { teams, isLoading: teamIsLoading } = useTeams();
  const groupingUserFromRedux = useSelector(
    (state) => state.groupingUser.allocationUsers
  );

  // if (!userTeamId) {
  //   return (
  //     <Stack height={"80vh"} justifyContent={"center"} alignItems={"center"}>
  //       <div style={{ padding: "20px", textAlign: "center" }}>
  //         <img src={icon} alt="error" style={{ height: "140px" }} />
  //         <h2>You have not been assigned to any team.</h2>
  //       </div>
  //     </Stack>
  //   );
  // }

  return (
    <div>
      <Header
        teams={teams}
        teamIsLoading={teamIsLoading}
        groupingUserFromRedux={groupingUserFromRedux}
      />
      <GroupingBoards />
    </div>
  );
});

export default AllocationGrouping;
